import type { EventBus, GameEvents } from './types';

export function createEventBus(): EventBus {
  const map = new Map<string, Set<(e: unknown) => void>>();
  return {
    on(k, fn) {
      let set = map.get(k);
      if (!set) {
        set = new Set();
        map.set(k, set);
      }
      set.add(fn as (e: unknown) => void);
      return () => set!.delete(fn as (e: unknown) => void);
    },
    emit<K extends keyof GameEvents>(k: K, e: GameEvents[K]) {
      const set = map.get(k);
      if (!set) return;
      for (const fn of Array.from(set)) {
        try {
          fn(e);
        } catch (err) {
          console.error(`[events] handler for ${String(k)} threw`, err);
        }
      }
    },
  };
}
